import React from 'react';

import css from './background-glow.module.scss';

export function BackgroundGlow() {
  return <div className={css.bg} />;
}
